import Vue from 'vue';
import { make } from 'vuex-pathify';

import api from '@/services/api';
import { arrayToObject } from '@/assets/js/utility';

const state = {
  isFromProfile: false,
  isScenarioAdded: false,
  models: {},
  modelsScenarios: {},
  scenariosElements: {},
  currentTimestepIndex: 0,
};

const mutations = {
  ...make.mutations(state),
  ADD_MODELS_SCENARIO(state, payload) {
    const { value, id } = payload;
    Vue.set(state.modelsScenarios, id, value);
  },
  ADD_SCENARIOS_ELEMENT_DATA(state, payload) {
    const { scenarioId, elementId, type, netType, value } = payload;
    // 🤮
    if (!state.scenariosElements[netType]) {
      Vue.set(state.scenariosElements, netType, {});
    }
    if (!state.scenariosElements[netType][scenarioId]) {
      Vue.set(state.scenariosElements[netType], scenarioId, {});
    }
    if (!state.scenariosElements[netType][scenarioId][type]) {
      Vue.set(state.scenariosElements[netType][scenarioId], type, {});
    }
    Vue.set(state.scenariosElements[netType][scenarioId][type], elementId, value);
  },
};

const actions = {
  async deleteModel(store, { id, netType }) {
    await api.delete(`${netType}/modeling_results/models/${id}`);
  },
  async getModels({ commit, state }, netType) {
    const r = await api.get(`${netType}/modeling_results/models`);
    commit('SET_MODELS', { ...(state.models || {}), [netType]: arrayToObject(r.data.data) });
    const scenarios = r.data.data.map(model => model.scenarios).flat();
    commit('SET_MODELS_SCENARIOS', { ...(state.modelsScenarios || {}), [netType]: arrayToObject(scenarios) });
  },
  async getModelScenarios({ commit }, { id, netType }) {
    const r = await api.get(`${netType}/modeling_results/models/${id}/scenarios`);
    commit('ADD_MODELS_SCENARIO', { id, value: r.data.data });
  },
  async getNetElementValues({ commit }, payload) {
    const { scenarioId, elementId, type, netType } = payload;
    const r = await api.get(`${netType}/modeling_results/scenarios/${scenarioId}/${type}/${elementId}/values`);
    commit(`ADD_SCENARIOS_ELEMENT_DATA`, { ...payload, value: r.data.data });
    return r.data.data;
  },
  async getModelingResultsTile(store, { envelope, scenarioId, type, netType }) {
    const r = await api.post(
      `/${netType}/modeling_results/scenarios/${scenarioId}/${type}/mvt`,
      { envelope },
      {
        responseType: 'arraybuffer',
        timeout: 0,
        skipDefaultErrorHandler: true,
      }
    );
    return r;
  },
  async getIntersectingLinks(store, { type, scenarioId, body }) {
    return await api.post(`sewer/modeling_results/scenarios/${scenarioId}/${type}`, body);
  },
  async getProfile(store, { date, pipes, scenarioId, index }) {
    const r = await api.post(
      `/sewer/modeling_results/profile/${scenarioId}`,
      {
        pipes,
        date,
        time_index: index,
      },
      {
        responseType: 'arraybuffer',
        timeout: 0,
      }
    );
    return r;
  },
  async getSewerDataProfile(store, payload) {
    return await api.post('sewer_analysis/profile', payload, { responseType: 'arraybuffer' });
  },
  async getInvertedGradientNodes(store, payload) {
    return await api.post(`sewer_analysis/inverted-gradient`, payload);
  },
  async getDownstreamNodes(store, payload) {
    const { oid, body } = payload;
    return await api.post(`sewer_analysis/downstream/${oid}`, body);
  },
  async getUpstreamNodes(store, payload) {
    const { oid, body } = payload;
    return await api.post(`sewer_analysis/upstream/${oid}`, body);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
